module.exports = __webpack_public_path__ + "img/logo.fd353df8.png";